export const customerPortal = {
  title: 'Ügyfélportál',
  subtitle: 'Önkiszolgáló felület ügyfelek részére',
  
  // Tabs
  tabs: {
    overview: 'Áttekintés',
    projects: 'Projektek',
    submissions: 'Beküldött űrlapok',
    missingItems: 'Hiányzó tételek',
    documents: 'Dokumentumok'
  },
  
  // Overview
  overview: {
    welcome: 'Üdvözöljük',
    noData: 'Nincs megjeleníthető adat',
    activeProjects: 'Aktív projektek',
    submittedRequests: 'Beküldött megbízások',
    missingDocuments: 'Hiányzó bizonylatok',
    closedProjects: 'Lezárt projektek'
  },
  
  // Projects
  projects: {
    title: 'Folyamatban lévő projektek',
    noProjects: 'Nincsenek folyamatban lévő projektek',
    description: 'Itt jelennek meg a folyamatban lévő projektjei'
  },
  
  // Submissions
  submissions: {
    title: 'Beküldött űrlapok',
    availableForms: 'Elérhető űrlapok - Új űrlap beküldése',
    mySubmissions: 'Beküldött űrlapok',
    noSubmissions: 'Nincs beküldött űrlap',
    description: 'Itt jelennek meg a beküldött űrlapjai és azok státusza',
    noForms: 'Nincs elérhető űrlap',
    noFormsDescription: 'Jelenleg nincsenek publikált űrlapok',
    clickToFill: 'Kattints a kitöltéshez',
    status: {
      draft: 'Piszkozat',
      pending: 'Feldolgozásra vár',
      submitted: 'Beküldve',
      processing: 'Feldolgozás alatt',
      completed: 'Feldolgozott',
      approved: 'Jóváhagyva',
      rejected: 'Elutasítva',
      hibernated: 'Hibernált'
    },
    submittedAt: 'Beküldve',
    notes: 'Megjegyzés',
    viewDetails: 'Részletek megtekintése',
    details: 'Űrlap részletei',
    formName: 'Űrlap neve',
    submissionDate: 'Beküldés dátuma',
    submittedData: 'Beküldött adatok',
    close: 'Bezárás'
  },
  
  // Missing Items
  missingItems: {
    title: 'Hiányzó tételek',
    warning: 'Figyelmeztetés',
    warningMessage: 'Felhívjuk szíves figyelmét, hogy nyilvántartásunk szerint hiányzó bizonylattal rendelkezik (olyan bizonylattal, amelyet nem adott át könyvelésre). A hiányzó bizonylat akadályozza a számviteli szolgáltatás teljesítését, amely bejelentési kötelezettséget vonhat maga után a NAV Pénzmosás Elleni Iroda irányába. Kérjük, hogy a hiányzó bizonylatot haladéktalanul szíveskedjen pótolni és a pótlás tényét a rendszerben jelezni. Együttműködését előre is köszönjük!',
    noItems: 'Nincs hiányzó tétel',
    description: 'Jelenleg nincsenek hiányzó tételek',
    acknowledge: 'Nyugtázom',
    markAsUploaded: 'Feltöltve jelzés',
    uploadFiles: 'Fájlok feltöltése',
    status: {
      pending: 'Függőben',
      acknowledged: 'Nyugtázva',
      uploaded: 'Feltöltve',
      approved: 'Jóváhagyva'
    },
    category: {
      invoice: 'Számla',
      receipt: 'Bizonylat',
      contract: 'Szerződés',
      document: 'Dokumentum',
      other: 'Egyéb'
    },
    priority: {
      low: 'Alacsony',
      medium: 'Közepes',
      high: 'Magas',
      urgent: 'Sürgős'
    },
    dueDate: 'Határidő',
    createdAt: 'Létrehozva'
  },
  
  // Documents
  documents: {
    title: 'Dokumentumok',
    noDocuments: 'Nincsenek dokumentumok',
    description: 'Itt jelennek meg a dokumentumai'
  }
};
